// export const apiUrl = process.env.API_URL || "http://localhost:4000";
export const apiUrl =
  "https://teammate-server.herokuapp.com" || "http://localhost:4000";
export const DEFAULT_MESSAGE_TIMEOUT = 3000;
export const DEFAULT_PAGINATION_LIMIT = 10;
